import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store'

// OIDC
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'
import Callback from '../views/oidc/Callback.vue'
import Error from '../views/oidc/Error.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue'),
    meta: { isPublic: true }
  },
  {
    path: '/create-room',
    name: 'create-room',
    component: () => import('../views/Home.vue'),
    props: { createRoom: true },
    meta: { isPublic: true }
  },
  {
    path: '/join-room',
    name: 'join-room',
    component: () => import('../views/Home.vue'),
    props: { joinRoom: true },
    meta: { isPublic: true }
  },
  {
    path: '/room/:roomId',
    name: 'room',
    component: () => import('../views/Room.vue'),
    props: true,
    meta: { isPublic: true }
  },
  {
    path: '/awesome-conference/:username',
    name: 'test',
    component: () => import('../views/ConferenceTest.vue'),
    props: true,
    meta: { isPublic: true }
  },
  {
    path: '/conference/:roomId',
    name: 'conferenceRoom',
    component: () => import('../views/ConferenceRoom.vue'),
    props: true,
    meta: { isPublic: true }
  },
  {
    path: '/RoomInfo/:roomId',
    name: 'room-info',
    component: () => import('../views/RoomInfo.vue'),
    props: true,
    meta: { isPublic: true }
  },
  {
    path: '/rooms',
    name: 'rooms',
    component: () => import('../views/RoomsList.vue'),
  },
  {
    path: '/dashboard',
    name: "dashboard",
    component: () => import("../views/Dashboard.vue"),
    meta: { isPublic: true }
  },
  {
    path: '/survey-online-user',
    name: "survey-online-user",
    component: () => import("../views/SurveyOnlineUser.vue"),
    meta: { isPublic: true }
  },
  {
    path: '/survey-online-rooms',
    name: 'survey-online-rooms',
    component: () => import('../views/SurveyOnlineRoomsList.vue'),
  },
  {
    path: "/room-asignation",
    name: "room-asignation",
    component: () => import("../views/AutomaticRoomAsignation.vue")
  },
  {
    path: '/online-user',
    name: "online-user",
    component: () => import("../views/OnlineUser.vue"),
    meta: { isPublic: true }
  },
  {
    path: '/online-rooms',
    name: 'online-rooms',
    component: () => import('../views/OnlineRoomsList.vue'),
  },
  {
    path: '/online-operator',
    name: "online-operator",
    component: () => import("../views/OnlineOperator.vue")
  },
  {
    path: '/supervisor-panel',
    name: 'supervisor-panel',
    component: () => import('../views/SupervisorPanel.vue')
  },
  {
    path: "/reports",
    name: 'reports',
    component: () => import("../views/Reports.vue")
  },
  // Lab
  {
    path: "/survey/:id",
    name: "survey",
    component: () => import("../views/surveys/Survey.vue"),
    props: true
  },
  // OIDC
  {
    path: '/oidc-callback',
    name: 'oidcCallback',
    component: Callback,
    meta: { isPublic: true }
  },
  {
    path: '/auth-error',
    name: 'oidcCallbackError',
    component: Error,
    meta: { isPublic: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidcStore'));

export default router
